import { Discovery } from 'aws-sdk'
import React, { useState } from 'react'
import './styles.scss'

export const ImageCaption = ({
  img,
  title,
  caption,
  source
}: {
  img: React.ReactChild | React.ReactChild[]
  title: React.ReactChild
  caption: React.ReactChild
  source?: React.ReactChild
}) => {
  return (
    <div className={'ImageCaption ' + (typeof img === 'object' ? 'obj' : '')}>
      <img
        src={
          typeof img === 'object'
            ? window.innerWidth < 711
              ? img[1]
              : img[0]
            : img
        }
      />
      <div className='overlay'>
        <Accordeon
          head={<div className='title'>{title}</div>}
          content={
            <>
              <div className='caption'>{caption}</div>
              {source && <div className='source'>{source}</div>}
            </>
          }
        />
      </div>
    </div>
  )
}

const Accordeon = ({
  head,
  content
}: {
  head: React.ReactChild
  content: React.ReactChild
}) => {
  const [open, setOpen] = useState(false)
  return (
    <div className={'accordeon ' + (open ? 'open' : '')}>
      <div className='head' onClick={() => setOpen(!open)}>
        {head}
      </div>
      <div className='content'>{content}</div>
    </div>
  )
}
